module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin leer 2.77291b79.svg";